<!-- Navbar Start -->
<nav
  class="navbar navbar-expand-lg bg-white navbar-light sticky-top px-4 px-lg-5 py-lg-0"
>
  <a
    *ngIf="currentLogos.length == 1"
    routerLink="/home"
    class="navbar-brand"
    routerLinkActive="active"
  >
    <img
      class="img-fluid"
      style="height: 6rem"
      src="assets/img/{{ currentLogos[0] }}"
      alt=""
    />
  </a>
  <div *ngIf="currentLogos.length > 1">
    <a routerLink="/home" class="navbar-brand" routerLinkActive="active">
      <img
        class="img-fluid"
        style="height: 6rem"
        src="assets/img/{{ currentLogos[0] }}"
        alt=""
      />
    </a>
    <a routerLink="/home" class="navbar-brand" routerLinkActive="active">
      <img
        class="img-fluid"
        style="height: 3rem"
        src="assets/img/{{ currentLogos[1] }}"
        alt=""
      />
    </a>
    <a routerLink="/home" class="navbar-brand" routerLinkActive="active">
      <img
        class="img-fluid"
        style="height: 3.5rem"
        src="assets/img/{{ currentLogos[2] }}"
        alt=""
      />
    </a>
  </div>
  <button
    type="button"
    class="navbar-toggler"
    data-bs-toggle="collapse"
    data-bs-target="#navbarCollapse"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarCollapse">
    <div class="navbar-nav mx-auto">
      <div *ngFor="let navItem of currentNavBar">
        <!-- Nav item without children Start-->
        <a
          *ngIf="!navItem.children?.length"
          routerLink="{{ navItem.url }}"
          class="nav-item nav-link"
          routerLinkActive="active"
          >{{ navItem.title | translate }}</a
        >
        <!-- Nav item without children End-->

        <!-- Nav item with children Start-->
        <div *ngIf="navItem.children?.length" class="nav-item dropdown">
          <span style="display: flex; align-items: center">
            <a
              routerLink="{{ navItem.url }}"
              routerLinkActive="active"
              class="nav-link dropdown-toggle"
              >{{ navItem.title | translate }}
            </a>
            <a class="fas fa-chevron-down" (click)="toggleDropdown($event)"></a>
          </span>
          <div
            class="dropdown-menu rounded-0 rounded-bottom border-0 shadow-sm m-0"
          >
            <a
              *ngFor="let navChild of navItem.children"
              routerLink="{{ navChild.url }}"
              fragment="{{ navChild.fragment }}"
              class="dropdown-item"
              >{{ navChild.title | translate }}</a
            >
          </div>
        </div>
        <!-- Nav item with children End-->
      </div>

      <!-- Language Nav item Start -->
      <div class="nav-item dropdown">
        <div style="display: flex; align-items: center">
          <a class="nav-link dropdown-toggle"
            >{{ selectedLanguage | translate }}
            <img
              src="../../../assets/img/{{ selectedLanguage }}-flag.png"
              alt=""
              width="24"
              height="16"
            />
          </a>
          <a class="fas fa-chevron-down" (click)="toggleDropdown($event)"></a>
        </div>

        <div
          class="dropdown-menu rounded-0 rounded-bottom border-0 shadow-sm m-0"
        >
          <a href="#" (click)="changeLanguage('en')" class="dropdown-item"
            >{{ "en" | translate }}
            <img
              src="../../../assets/img/en-flag.png"
              alt=""
              width="24"
              height="16"
            />
          </a>
          <a href="#" (click)="changeLanguage('fr')" class="dropdown-item"
            >{{ "fr" | translate }}
            <img
              src="../../../assets/img/fr-flag.png"
              alt=""
              width="24"
              height="16"
          /></a>
          <a href="#" (click)="changeLanguage('ar')" class="dropdown-item"
            >{{ "ar" | translate }}
            <img
              src="../../../assets/img/ar-flag.png"
              alt=""
              width="24"
              height="16"
          /></a>
        </div>
      </div>
      <!-- Language Nav item End -->
    </div>
  </div>
</nav>
<!-- Navbar End -->
